module.exports = __webpack_public_path__ + "img/cd.fc78a6b4.svg";